// SidebarProjectHeader Component

import React from 'react'
import PropTypes from 'prop-types'
import { ModalHeader } from '@rodeo-dev/legos'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'

const SidebarProjectHeader = ({ onClose }) => (
  <ModalHeader onClose={onClose}>
    <IntlMessage ident='projectV2.header.title' />
  </ModalHeader>
)

SidebarProjectHeader.propTypes = {
  onClose: PropTypes.func
}

SidebarProjectHeader.defaultProps = {}

export default SidebarProjectHeader
